import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Image from '../../../Image';
import { announcementThumbUrlForPose } from './announcementThumbnail';

export default function SchoolAnnouncementThumbnail({ poseUrl, fallbackSrc, classes }) {
  const initial = announcementThumbUrlForPose(poseUrl) || fallbackSrc;
  const [src, setSrc] = useState(initial);

  useEffect(() => {
    setSrc(announcementThumbUrlForPose(poseUrl) || fallbackSrc);
  }, [poseUrl, fallbackSrc]);

  return (
    <Image
      // key forces a remount when src swaps to the fallback: Image latches its
      // internal error state and renders null forever otherwise, so a school
      // without an S3 file would show a blank tile instead of the fallback.
      key={src}
      src={src}
      alt=""
      classes={classes}
      onError={() => { if (src !== fallbackSrc) setSrc(fallbackSrc); }}
    />
  );
}

SchoolAnnouncementThumbnail.propTypes = {
  poseUrl: PropTypes.string,
  fallbackSrc: PropTypes.string.isRequired,
  classes: PropTypes.string,
};

SchoolAnnouncementThumbnail.defaultProps = {
  poseUrl: null,
  classes: undefined,
};
